import { ConsultantComponent } from "./consultant/consultant.component";
import { UnderConstructionComponent } from "./permits/permit-application/shared/under-construction/under-construction.component";
import { InvoiceComponent } from "./carrier-account/statement/invoice/invoice.component";
import { ModuleWithProviders, Component } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { AuthGuard } from "./auth.guard";
import { VehicleTypeComponent } from "./maintain/vehicle-type/vehicle-type.component";
import { ListVehicleTypeComponent } from "./maintain/list-vehicle-type/list-vehicle-type.component";
import { VehicleMakeComponent } from "./maintain/vehicle-make/vehicle-make.component";
import { ListVehicleMakeComponent } from "./maintain/list-vehicle-make/list-vehicle-make.component";
import { ListPermitTypeComponent } from "./maintain/list-permit-type/list-permit-type.component";
import { PermitTypeComponent } from "./maintain/permit-type/permit-type.component";
import { StatusComponent } from "./maintain/status/status.component";
import { ListStatusComponent } from "./maintain/list-status/list-status.component";
import { CarrierTypeComponent } from "./maintain/carrier-type/carrier-type.component";
import { ListCarrierTypeComponent } from "./maintain/list-carrier-type/list-carrier-type.component";
import { LoginComponent } from "./login/login.component";
import { RegisterComponent } from "./register/register.component";
import { AmmenduserComponent } from "./ammenduser/ammenduser.component";
import { CaLandingPageComponent } from "./ca-landing-page/ca-landing-page.component";
import { UsernameComponent } from "./forgot/username/username.component";
import { ForgotComponent } from "./forgot/forgot.component";
import { ResetComponent } from "./reset/reset.component";
import { CompanydetailsComponent } from "./companydetails/companydetails.component";
import { ManagementComponent } from "./carrier-account/management/management.component";
import { UploaddocumentComponent } from "./uploaddocument/uploaddocument.component";
import { ConfirmpasswordchangeComponent } from "./reset/confirmpasswordchange/confirmpasswordchange.component";
import { CaContactPageComponent } from "../app/ca-contact-page/ca-contact-page.component";
import { ListDocumentTypeComponent } from "./maintain/list-document-type/list-document-type.component";
import { DocumentTypeComponent } from "./maintain/document-type/document-type.component";
import { PermitApplicationComponent } from "./permits/permit-application/permit-application.component";
import { NewPermitApplicationComponent } from "./permits/permit-application/new-permit-application/new-permit-application.component";
import { ViewPermitApplicationComponent } from "./permits/permit-application/view-permit-application/view-permit-application.component";
import { ListCarrierTypeDocumentComponent } from "./maintain/list-carrier-type-document/list-carrier-type-document.component";
import { CarrierTypeDocumentComponent } from "./maintain/carrier-type-document/carrier-type-document.component";
import { TransportAssociationComponent } from "./maintain/transport-association/transport-association.component";
import { TransportAssociationListComponent } from "./maintain/list-transport-association/transport-association-list.component";
import { WorkflowdashboardComponent } from "./workflow/workflowdashboard/workflowdashboard.component";
import { ListPermitTypeDocumentComponent } from "./maintain/list-permit-type-document/list-permit-type-document.component";
import { PermitTypeDocumentComponent } from "./maintain/permit-type-document/permit-type-document.component";
import { ErrorsComponent } from "./shared/errors/errors.component";
import { ActivateAccountComponent } from "./activate-account/activate-account.component";
import { ApprovalManagerComponent } from "./approval-manager/approval-manager.component";
import { PermitApprovalListComponent } from "./approval-manager/permit-approval-list/permit-approval-list.component";
import { PermitCorrespondenceComponent } from "./approval-manager/permit-correspondence/permit-correspondence.component";
import { PermitViewerComponent } from "./application-approval/permit-viewer/permit-viewer.component";
import { CarriercorrespondenceComponent } from "./carrier-account/approve/carriercorrespondence/carriercorrespondence.component";
import { ManagerComponent } from "./carrier-account/approve/manager/manager.component";
import { AddRouteComponent } from "./maintain/route-management/add-route/add-route.component";
import { ListRouteComponent } from "./maintain/route-management/list-route/list-route/list-route.component";
import { ListSessionComponent } from "./maintain/list-session/list-session.component";
import { ManageCountriesComponent } from "./maintain/manage-countries/manage-countries.component";
import { ManageCountryPlacesComponent } from "./maintain/manage-country-places/manage-country-places.component";
import { AddNewPlaceComponent } from "./maintain/add-new-place/add-new-place.component";
import { ListPermitTypeVehicleComponent } from "./maintain/list-permit-type-vehicle/list-permit-type-vehicle.component";
import { CorspdcComponent } from "./corspdc/corspdc.component";
import { PermitListApplicationComponent } from "./permit-list-application/permit-list-application.component";
import { PermitCertificateReturnComponent } from "./maintain/permit-certificate-return/permit-certificate-return.component";
import { RunMaintenanceTasksComponent } from "./maintain/run-maintenance-tasks/run-maintenance-tasks.component";
import { RunCorrespondenceTasksComponent } from "./maintain/run-correspondence-tasks/run-correspondence-tasks.component";
import { BatchComponent } from "./corspdc/batch/batch.component";
import { StatementComponent } from "./carrier-account/statement/statement.component";
import { LinkCarrierAccountComponent } from "./carrier-account/link-carrier-account/link-carrier-account.component";
import { DeLinkCarrierAccountComponent } from "./carrier-account/delink-carrier-account/delink-carrier-account.component";
import { ManageComponent } from "./permits/permit-application/timetable/manage/manage.component";
import { TimetableComponent } from "./permits/permit-application/timetable/timetable.component";
import { ExtractViewsComponent } from "./extract-views/extract-views/extract-views.component";
import { RunExtractsComponent } from "./extract-views/extract-views/run-extracts/run-extracts.component";
import { AddDataExtractComponent } from "./extract-views/extract-views/add-data-extract/add-data-extract.component";
import { ViewPermitComponent } from "./maintain/view-permit/view-permit.component";
import { RenewPermitComponent } from "./permits/permit-application/renew-permit/renew-permit.component";
import { ManageVehiclesComponent } from "./maintain/manage-vehicles/manage-vehicles.component";
import { ExternalVehiclesComponent } from "./maintain/external-vehicles/external-vehicles.component";
import { CarrierDetailsComponent } from "./permits/permit-application/shared/carrier-details/carrier-details.component";
import { CalendarViewerComponent } from "./shared/calendar-viewer/calendar-viewer.component";
import { ListFreightTypeComponent } from "./maintain/list-freight-type/list-freight-type.component";
import { EditFreightTypeComponent } from "./maintain/edit-freight-type/edit-freight-type.component";

import { CarrierComplianceListComponent } from "./compliance/carrier-compliance-list/carrier-compliance-list.component";
import { ComplianceReturnListComponent } from "./compliance/compliance-return-list/compliance-return-list.component";
import { ReportsForSanralComponent } from './powerbireports/reports-for-sanral/reports-for-sanral.component';
import { SupportComponent } from "./support/support.component";
import { SupportNewComponent } from "./support-new/support-new.component";
import { ComplianceApplicationComponent } from "./compliance/compliance-application/compliance-application.component";
import { PrintingComponent } from "./approval-manager/printing/printing.component";
import { AccountDepositComponent } from "./PayGate/accountDeposit.component";
import { PaymentCompleteComponent } from "./PayGate/PaymentComplete/paymentComplete.component";
import { FacebookpolicyComponent } from "./facebookpolicy/facebookpolicy.component";
import { SharedModule } from './shared.module';
import { ListScannerComponent } from "./maintain/list-scanner/list-scanner.component";
import { AddScannerComponent } from "./maintain//add-scanner/add-scanner.component";
import { CarrierStepperComponent } from "./carrier-stepper/carrier-stepper.component";
import { ResendRegistrationComponent } from "./resend-registration/resend-registration.component";
import { CarrierCongratulationsComponent } from "./carrier-congratulations/carrier-congratulations.component";
import { PermitStepperComponent } from "./permits/permit-application/permit-stepper/permit-stepper.component";
import { CaLandingPageNoaccountComponent } from "./ca-landing-page-noaccount/ca-landing-page-noaccount.component";
import { PermitCongratulationsComponent } from "./permit-congratulations/permit-congratulations.component";
import { TestingComponent } from "./testing/testing.component";
import { ModifyDetailsComponent } from "./application-approval/shared/modify-details/modify-details.component";
import { OcasStepperComponent } from "./ocas-stepper/ocas-stepper.component";
import { OcasAuditComponent } from "./ocas-audit/ocas-audit.component";
import { ComplianceprocessesComponent } from "./annual-compliance/complianceprocesses/complianceprocesses.component";
import { ViewComplianceDetailsComponent } from './annual-compliance/view-compliance-details/view-compliance-details.component';
import { MonthlyComplianceListComponent } from "./monthly-compliance/monthly-compliance-list/monthly-compliance-list.component";
import {PassengerPermitsComponent} from './monthly-compliance/passenger-permits/passenger-permits.component';
import {CarrierReportsComponent} from './powerbireports/carrier-reports/carrier-reports.component';
import { ReportsForAdminComponent } from './powerbireports/reports-for-admin/reports-for-admin.component';

import { WFActionsComponent } from "./workflow/admin/wfactions/wfactions.component";
import { WFRouteTypeComponent } from "./workflow/admin/wfroute-type/wfroute-type.component";
import { WFRoutesComponent } from "./workflow/admin/wfroutes/wfroutes.component";
import { WFStatusComponent } from "./workflow/admin/wfstatus/wfstatus.component";
import { DashboardComponent } from "./workflow/management/dashboard/dashboard.component";
import { MyinboxComponent } from "./workflow/myinbox/myinbox.component";
import { UnassignedComponent } from "./workflow/unassigned/unassigned.component";
import { ProcesstrackingComponent } from "./workflow/processtracking/processtracking.component";
import { ProcessviewComponent } from "./workflow/processview/processview.component";
import { PassengerListComponent } from "./compliance/passenger-list/passenger-list.component";
import { AdminMonthlyComplianceComponent } from "./monthly-compliance/admin-monthly-compliance/admin-monthly-compliance.component";
import {ReportsComponent} from './powerbireports/reports/reports.component';
import { AdminAnnualComplianceListComponent } from "./admin-annual-compliance/admin-annual-compliance-list/admin-annual-compliance-list.component";

import {InternalRouteGuard} from './guards/InternalRouteGuard';
import { WfescalationComponent } from "./workflow/admin/wfescalation/wfescalation.component";
import { WfdelegationComponent } from "./workflow/admin/wfdelegation/wfdelegation.component";
import { ListGazettesComponent } from "./gazetting/list-gazettes/list-gazettes.component";
import { ViewEditGazettesComponent } from "./gazetting/view-edit-gazettes/view-edit-gazettes.component";
import { SelectApplicationsComponent } from "./gazetting/select-applications/select-applications.component";
import { WfmanageactivityComponent } from "./workflow/management/wfmanageactivity/wfmanageactivity.component";


const appRoutes: Routes = [
  //Public routes

  // { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: "annual-compliance",
    loadChildren: () =>
      import("./annual-compliance/annual-compliance.module").then(
        (m) => m.AnnualComplianceModule
      ),
  },
  {
    path: "admin-annual-compliance",
    loadChildren: () =>
      import(
        "../app/admin-annual-compliance/admin-annual-compliance.module"
      ).then((m) => m.AdminAnnualComplianceModule),
  },
  {
    path: "carrier-driver",
    loadChildren: () =>
      import("./carrier-driver/carrier-driver.module").then(
        (m) => m.CarrierDriverModule
      ),
  },
  { path: "testing", component: TestingComponent },
  { path: "home", component: HomeComponent },
  { path: "", component: LoginComponent, pathMatch: "full" },
  { path: "login", component: LoginComponent },
  { path: "activate/:id", component: ActivateAccountComponent },
  { path: "facebook-privacy", component: FacebookpolicyComponent },
  { path: "stepper", component: CarrierStepperComponent },
  { path: "ocas-stepper/:id", component: OcasStepperComponent },
  //AccountDeposit
  { path: "carrier/fundaccount/:id", component: AccountDepositComponent },
  {
    path: "carrier/paymentcomplete/:id/:status/:refNum",
    component: PaymentCompleteComponent,
  },

  //Admin routes

  //{ path: 'statuses/edit/:id', component: StatusmanageComponent, canActivate: [AuthGuard], data: { Roles: ['SUPERUSER', 'ADMIN'] } },
  //VehicleTypeComponent
  { path: "vehicle/type/add", component: VehicleTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "vehicle/type/edit/:id", component: VehicleTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "vehicle/type/list", component: ListVehicleTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "freight/type/list", component: ListFreightTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "freight/type/add", component: EditFreightTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "freight/type/edit/:id", component: EditFreightTypeComponent , canActivate: [InternalRouteGuard]},

  //VehicleMakeCompofnent
  { path: "vehicle/make/add", component: VehicleMakeComponent , canActivate: [InternalRouteGuard]},
  { path: "vehicle/make/edit/:id", component: VehicleMakeComponent , canActivate: [InternalRouteGuard]},
  { path: "vehicle/make/list", component: ListVehicleMakeComponent , canActivate: [InternalRouteGuard]},
  //PermitTypeComponent
  { path: "permit/type/add", component: PermitTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "permit/type/edit/:id", component: PermitTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "permit/type/list", component: ListPermitTypeComponent , canActivate: [InternalRouteGuard]},
  //StatusComponent
  { path: "status/add", component: StatusComponent , canActivate: [InternalRouteGuard]},
  { path: "status/edit/:id", component: StatusComponent , canActivate: [InternalRouteGuard]},
  { path: "status/list", component: ListStatusComponent , canActivate: [InternalRouteGuard]},

  //CarrierTypeComponent
  { path: "carrier/type/add", component: CarrierTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "carrier/type/edit/:id", component: CarrierTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "carrier/type/list", component: ListCarrierTypeComponent , canActivate: [InternalRouteGuard]},

  //CompanyDetails
  { path: "carrier/companydetails/add", component: CompanydetailsComponent },
  {
    path: "carrier/companydetails/edit/id",
    component: CompanydetailsComponent,
  },
  { path: "carrier/companydetails/list", component: CompanydetailsComponent },

  //TransportAssociation
  {
    path: "transport/association/add",
    component: TransportAssociationComponent , canActivate: [InternalRouteGuard]
  },
  {
    path: "transport/association/edit/:id",
    component: TransportAssociationComponent , canActivate: [InternalRouteGuard]
  },
  {
    path: "transport/association/list",
    component: TransportAssociationListComponent, canActivate: [InternalRouteGuard]
  },

  //CarrieAcoount
  { path: "carrier/create/contact", component: CaContactPageComponent },
  //PowerBI Reports
  { path: "carrier/reports/:id", component: CarrierReportsComponent },
  { path: "sanral/reports", component: ReportsForSanralComponent },
  { path: "admin/reports", component: ReportsForAdminComponent },
  { path: "reports", component: ReportsComponent },
 

  //LoginComponent

  //RegisterComponent
  { path: "register", component: RegisterComponent },
  {
    path: "registrationdone/:communicationType/:value/:email/:mobile",
    component: ResendRegistrationComponent,
  },
  { path: "ammenduser", component: AmmenduserComponent },
  { path: "forgot/username", component: UsernameComponent },
  { path: "forgot", component: ForgotComponent },
  { path: "reset", component: ResetComponent },
  //Carrier Account Management
  { path: "carrier/accounts", component: CaLandingPageComponent },
  { path: "carrier/accounts/:id", component: CaLandingPageComponent },
  { path: "carrier/application-permit", component: CaLandingPageComponent },
  { path: "carrier/account/add", component: CarrierStepperComponent },
  { path: "carrier/account/edit/:id", component: CarrierStepperComponent },
  { path: "carrier/account/edit/:id/:status", component: ManagementComponent },
  {
    path: "carrier/landingpage/noaccount",
    component: CaLandingPageNoaccountComponent,
  },

  { path: "reset/confirm/:token", component: ConfirmpasswordchangeComponent },

  //Carrier Transcations
  { path: "carrier/statement/:id/:carrierid", component: StatementComponent },
  {
    path: "carrier/invoice/:id/:referencenumber/:carrierid",
    component: InvoiceComponent,
  },

  //Session Management
  { path: "session/list", component: ListSessionComponent , canActivate: [InternalRouteGuard]},
  //Scanner
  { path: "scanner/list", component: ListScannerComponent , canActivate: [InternalRouteGuard]},
  { path: "scanner/add", component: AddScannerComponent , canActivate: [InternalRouteGuard]},
  { path: "scanner/edit/:id", component: AddScannerComponent , canActivate: [InternalRouteGuard]},

  //Documents
  { path: "carrier/account/document/:id", component: UploaddocumentComponent },
  { path: "document/type/add", component: DocumentTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "document/type/edit/:id", component: DocumentTypeComponent , canActivate: [InternalRouteGuard]},
  { path: "document/type/list", component: ListDocumentTypeComponent , canActivate: [InternalRouteGuard]},

  //Contact Page
  { path: "contact/details/add", component: CaContactPageComponent },
  //New Permit Applications
  {
    path: "carrier/permit/application/new/:id",
    component: PermitStepperComponent,
  },
  {
    path: "carrier/permit/application/change/:id/correction",
    component: PermitStepperComponent,
  },
  {
    path: "carrier/permit/application/edit/:id",
    component: PermitStepperComponent,
  },
  {
    path: "annualcompliance/permit/application/edit/:id",
    component: PermitStepperComponent,
  },
  {
    path: "carrier/permit/application/edit/:id/:isSelectedVehicle",
    component: PermitStepperComponent,
  },
  {
    path: "carrier/permit/application/edit/:id/:steppernumber/:fromRoute",
    component: PermitStepperComponent,
  },
  { path: "permit-success/:id", component: PermitCongratulationsComponent },
  {
    path: "carrier/permit/application/view/:id",
    component: PermitStepperComponent,
  },
  {
    path: "carrier/permit/application/annual/view/:id",
    component: PermitStepperComponent,
  },
  {
    path: "history/permit/application/view/:id",
    component: PermitStepperComponent,
  },
  {
    path: "carrier/monthly-returns/:carrierid/:permitid/:compliancereturnid",
    component: PassengerPermitsComponent,
  },

  //Permit Applications
  {
    path: "carrier/permit/application/:id",
    component: PermitApplicationComponent,
  },
  {
    path: "carrier/permit/application/mypermits/:id",
    component: PermitListApplicationComponent,
  },
  {
    path: "admin/monthly-compliance",
    component: AdminMonthlyComplianceComponent, canActivate: [InternalRouteGuard]
  },
  {
    path: "carrier/permit/application/cancel/permit/:id/:appid",
    component: PermitListApplicationComponent,
  },
  // { path: 'carrier/permit/application/new/:id', component: NewPermitApplicationComponent },
  {
    path: "carrier/permit/application/renew/:id/:crId/:type",
    component: RenewPermitComponent,
  },
  // { path: 'carrier/permit/application/edit/:id', component: NewPermitApplicationComponent },
  // { path: 'carrier/permit/application/edit/:id/:isSelectedVehicle', component: NewPermitApplicationComponent },
  {
    path: "carrier/permit/application/change/:id/:ctrlType",
    component: NewPermitApplicationComponent,
  },
  {
    path: "carrier/permit/application/change/:id/:ctrlType/:selectType",
    component: NewPermitApplicationComponent,
  },

  {
    path: "carrier/permit/application/change/:id/vehicle/selected-vehicle",
    component: NewPermitApplicationComponent,
  },
  {
    path: "carrier/permit/application/duplicate/:id",
    component: NewPermitApplicationComponent,
  },
  {
    path: "carrier/permit/application/duplicate/edit/:id",
    component: NewPermitApplicationComponent,
  },
  {
    path: "carrier/permit/application/change/:id",
    component: NewPermitApplicationComponent,
  },
  {
    path: "carrier/process/permit/application/:id",
    component: PermitViewerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "carrier/process/permit/application/details/:id",
    component: PermitViewerComponent,
    canActivate: [AuthGuard],
  },

  {
    path: "carrier/modify/permit/application/:id",
    component: ModifyDetailsComponent,
    canActivate: [AuthGuard],
  },

  // { path: 'carrier/permit/application/view/:id', component: NewPermitApplicationComponent },
  {
    path: "carrier/permit/application/view/:id/:constatus",
    component: NewPermitApplicationComponent,
  },

  {
    path: "carrier/permit/edit/:id/:edit",
    component: ViewPermitApplicationComponent,
  },
  {
    path: "carrier/documenttype/list",
    component: ListCarrierTypeDocumentComponent , canActivate: [InternalRouteGuard]
  },
  { path: "carrier/documenttype/add", component: CarrierTypeDocumentComponent , canActivate: [InternalRouteGuard]},
  {
    path: "carrier/documentttype/edit/:id",
    component: CarrierTypeDocumentComponent , canActivate: [InternalRouteGuard]
  },

  { path: "carrier-details", component: CarrierDetailsComponent },
  { path: "congratulations", component: CarrierCongratulationsComponent },
  { path: "congratulations/:id", component: CarrierCongratulationsComponent },

  //Consultants
  { path: "carrier/consultant/:id", component: ConsultantComponent },

  { path: "route/management/add", component: AddRouteComponent , canActivate: [InternalRouteGuard]},
  { path: "route/management/list", component: ListRouteComponent , canActivate: [InternalRouteGuard]},
  { path: "route/management/edit/:id", component: AddRouteComponent , canActivate: [InternalRouteGuard]},
  {
    path: "route/management/edit/:id/:applicationid",
    component: AddRouteComponent,
  },
  {
    path: "route/management/edit/:id/:applicationid/:carrierId",
    component: AddRouteComponent,
  },
  {
    path: "route/management/edit/:id/:applicationid/:carrierId/:permitId",
    component: AddRouteComponent,
  },
  {
    path: "permit/certificate/return",
    component: PermitCertificateReturnComponent , canActivate: [InternalRouteGuard]
  },

  //Admin View Permits
  { path: "maintain-view-permit", component: ViewPermitComponent , canActivate: [InternalRouteGuard]},

  //Workflow
  { path: "workflow/dashboard/list", component: WorkflowdashboardComponent , canActivate: [InternalRouteGuard]},
  { path: "approvals/permit/edit/:id", component: PermitViewerComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/myinbox", component: MyinboxComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/unassigned", component: UnassignedComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/carrier/approval/:id/:role/:act", component: ProcessviewComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/permit/approval/:id/:role/:act", component: ProcessviewComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/compliance/approval/:id/:role/:act", component: ProcessviewComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/tracking", component: ProcesstrackingComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/dashboard", component: DashboardComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/manage", component: WfmanageactivityComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/admin/status", component: WFStatusComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/admin/route", component: WFRoutesComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/admin/routetype", component: WFRouteTypeComponent , canActivate: [InternalRouteGuard]},
   { path: "workflow/admin/actions", component: WFActionsComponent , canActivate: [InternalRouteGuard]}, 
   { path: "workflow/admin/delegation", component: WfdelegationComponent }, 
   { path: "workflow/admin/escalation", component: WfescalationComponent }, 

  //Permit type document
  {
    path: "permit/documenttype/list",
    component: ListPermitTypeDocumentComponent , canActivate: [InternalRouteGuard]
  },
  { path: "permit/documenttype/add", component: PermitTypeDocumentComponent , canActivate: [InternalRouteGuard]},
  {
    path: "permit/documentttype/edit/:id",
    component: PermitTypeDocumentComponent , canActivate: [InternalRouteGuard]
  },

  //Permit type document
  {
    path: "permit/documenttype/list",
    component: ListPermitTypeDocumentComponent,
  },
  { path: "permit/documenttype/add", component: PermitTypeDocumentComponent },
  {
    path: "permit/documentttype/edit/:id",
    component: PermitTypeDocumentComponent,
  },

  //approval-manager flow
  { path: "permit/approval", component: ApprovalManagerComponent , canActivate: [InternalRouteGuard] },
  { path: "permit/approval/approved", component: ApprovalManagerComponent , canActivate: [InternalRouteGuard]},
  { path: "permit/approval/printed", component: ApprovalManagerComponent , canActivate: [InternalRouteGuard]},
    //View Permit History of Carrier
  { path: "admin-annual-compliance/list", component: AdminAnnualComplianceListComponent , canActivate: [InternalRouteGuard]},
  { path: "permit/history/:carrierid", component: PermitListApplicationComponent },
  {
    path: "permit/approval/correspondence/:id",
    component: PermitCorrespondenceComponent,
  },
  {
    path: "permit/approval/view/:id",
    component: NewPermitApplicationComponent,
  },
  { path: "account/approval", component: ManagerComponent , canActivate: [InternalRouteGuard]},
  {
    path: "carrier/account/approval/:id",
    component: ManagerComponent, canActivate: [InternalRouteGuard]
  },
  {
    path: "carrier/approval/correspondence",
    component: CarriercorrespondenceComponent,
  },
  {
    path: "permit/approval/printing/:pId/:isapproved",
    component: PrintingComponent,
  },

  //Admin Manage Countries
  { path: "countries/list", component: ManageCountriesComponent , canActivate: [InternalRouteGuard]},
  { path: "countries/list/:type", component: ManageCountryPlacesComponent , canActivate: [InternalRouteGuard]},
  { path: "countries/add/:id", component: AddNewPlaceComponent , canActivate: [InternalRouteGuard]},
  { path: "countries/edit/:id/:placeId", component: AddNewPlaceComponent , canActivate: [InternalRouteGuard]},
  //vehicle permit
  {
    path: "permit/vehicletype/list",
    component: ListPermitTypeVehicleComponent,canActivate: [InternalRouteGuard]
  },
  { path: "permit/vehicles", component: ManageVehiclesComponent },
  { path: "permit/my-vehicles/:appid", component: ManageVehiclesComponent },
  {
    path: "permit/my-vehicles/:carrierid/:carriercode",
    component: ManageVehiclesComponent,
  },
  { path: "permit/vehicle-replace/:appid", component: ManageVehiclesComponent },

  //Run maintanance tasks
  { path: "maintenance/tasks", component: RunMaintenanceTasksComponent , canActivate: [InternalRouteGuard] },
  { path: "correspondence/tasks", component: RunCorrespondenceTasksComponent , canActivate: [InternalRouteGuard] },

  //under-construction
  { path: "under-construction", component: UnderConstructionComponent },

  //Correspondences
  { path: "corspdc/list", component: CorspdcComponent , canActivate: [InternalRouteGuard]},
  { path: "corspdc/batch", component: BatchComponent , canActivate: [InternalRouteGuard]},

  //Carrier account linking
  { path: "carrier/account/link", component: LinkCarrierAccountComponent },
  { path: "carrier/account/delink", component: DeLinkCarrierAccountComponent },
  { path: "timetable", component: TimetableComponent },

  //extract views
  { path: "data", component: ExtractViewsComponent , canActivate: [InternalRouteGuard]},
  { path: "data/run/extracts", component: RunExtractsComponent , canActivate: [InternalRouteGuard]},
  { path: "data/add/extract", component: AddDataExtractComponent , canActivate: [InternalRouteGuard] },

  //External Vehicles
  { path: "carrier/externalvehicles", component: ExternalVehiclesComponent },
  { path: "carrier/vehicle/list", component: ExternalVehiclesComponent },

  //Calendar Viewer
  { path: "calendar/viewer", component: CalendarViewerComponent },

  //carrier compliace list CarrierComplianceListComponent
  {
    path: "carrier/compliance/list",
    component: CarrierComplianceListComponent,
  },
  {
    path: "carrier/compliance/return/list",
    component: ComplianceReturnListComponent,
  },
  {
    path: "carrier/compliance/return/list/:carrierid/:calendarid",
    component: ComplianceReturnListComponent,
  },
  {
    path: "carrier/compliance/return/list/:carrierid/:calendarid/:action/:appId",
    component: ComplianceReturnListComponent,
  },
  {
    path: "carrier/compliance/application",
    component: ComplianceApplicationComponent,
  },
  { path: "compliance-process/:id", component: ComplianceprocessesComponent , },
  { path: "view-compliance-process/:id", component: ViewComplianceDetailsComponent , },
  { path: "annual-compliance/list/:id", component: CarrierComplianceListComponent },
  { path: "annual-compliance/list/:id", component: CarrierComplianceListComponent },
  { path: "monthly-compliance/list/:id", component: MonthlyComplianceListComponent },
  { path: "monthly-compliance-passenger/list/:id/:carrierid/:permitid/:compliancereturnid", component: PassengerListComponent },

  // Gazetting

  { path: "list/gazettes", component: ListGazettesComponent },
  { path: "view/edit/gazettes/:id", component: ViewEditGazettesComponent },
  { path: "select/gazettes/:id", component: SelectApplicationsComponent },
  { path: "select/gazettes/application/:id", component: SelectApplicationsComponent },
  // {path:'support',component: SupportComponent},
  { path: "support", component: SupportNewComponent },
  { path: "**", component: ErrorsComponent },

];

export const appRouting: ModuleWithProviders<unknown> =
  RouterModule.forRoot(appRoutes);
